import { BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { FailReportComponent } from "./components/FailReportComponent";
import { Home } from './components/Home';
import { LoginComponent } from "./components/LoginComponent";
import { SvnRepositoryComponent } from './components/SVNRepositoryConponent';
import { RMATrackingComponent } from './components/RMATrackingComponent';
import { RoleComponent } from './components/RoleComponent';
import { TestingDetails } from './components/testing_visual/TestingDetails';
import { TestingMain } from './components/testing_visual/TestingMain';
import { TestingOverview } from './components/testing_visual/overview/TestingOverview';
import { UserComponent } from './components/UserComponent';
import { AnalyzedUnitComponent } from './components/AnalyzedUnitComponent';
import { TestingFilePage } from './components/testing_visual/TestingFile';
import { UpdateLimitComponent } from './components/update_limit/UpdateLimitComponent';
import { UpdateLimitPlotConponent } from './components/update_limit/UpdateLimitPlotConponent';
import { OverTimePlot } from './components/testing_visual/overview/OverTimePlot';
import { HistogramPlot } from './components/testing_visual/overview/HistogramPlot';
import { FileSyncComponent } from './components/FileSyncConponent';
import { ForceChangePasswordComponent } from './components/ForceChangePasswordComponent';
import { IssueOverviewComponent } from './components/IssueOverview';
import { PhoneHome } from './components/phone/Home';
import { PhoneIssueOverviewComponent } from './components/phone/TestingSummary';
import { PhoneWaiveUnitComponent } from './components/phone/WaiveUnitComponent';
import { AllTestingFiles } from './components/testing_visual/AllTestingFiles';
import { DashboardComponent } from './components/DashboardComponent';
import { EquipmentComponent } from './components/EquipmentComponent';
import { EquipmentComponentPrintQrFrame } from './components/EquipmentComponentPrintQR';
import { OtherSequenceParametersComponent } from './components/OtherSequenceParametersComponent';
import { LocalServerAuthComponent } from './components/LocalServerAuth';
import { useContext, useEffect, useRef } from 'react';
import { DetailIdContext } from './context';
import { DeletingTestingFileComponent } from './components/DeletingTestingFileComponent';
import { ExportCsvBySerials } from './components/ExportCsvBySerials';
import { RefurbishmentComponent } from './components/RefurbishmentComponent';
import { TestingDataFilterComponent } from './components/TestingDataFilterComponent';
import { TestingDataBatchSerialComponent } from './components/TestingDataBatchSerialComponent';
import { MatchingList } from './components/testing_visual/MatchingList';
import { MatchingView } from './components/testing_visual/MatchingView';

export const routesConfig = [
    {
        path: '/login',
        exact: true,
        component: LoginComponent
    },
    {
        path: '/force_change_password',
        exact: true,
        component: ForceChangePasswordComponent
    },
    {
        path: '/testing_visual/:testing_id',
        component: TestingMain,
        routes: [
            {
                path: '/testing_visual/:testing_id/overview',
                exact: true,
                component: TestingOverview
            },
            {
                path: '/testing_visual/:testing_id/detail',
                exact: true,
                component: TestingDetails
            }
        ]
    },
    {
        path: '/testing_file_visual/:id',
        exact: true,
        component: TestingFilePage
    },
    {
        path: '/testing_file_visual/:id/:activeTabIndex/:measurementKey',
        exact: true,
        component: TestingFilePage
    },
    {
        path: '/update_limit_plot/:id',
        exact: true,
        component: UpdateLimitPlotConponent
    },
    {
        path: '/overview_parameters_over_time/:id/:params',
        exact: true,
        component: OverTimePlot
    },
    {
        path: '/overview_parameters_for_histogram/:id/:params',
        exact: true,
        component: HistogramPlot
    },
    {
        path: '/inventory_print_qr_frame',
        exact: true,
        component: EquipmentComponentPrintQrFrame
    },
    {
        path: '/matchings/:id',
        exact: true,
        component: MatchingView
    },
    {
        path: '/matchings/:id/:sn',
        exact: true,
        component: MatchingView
    },
    {
        path: '/phone',
        component: PhoneHome,
        routes: [
            {
                path: '/phone/analyzed_unit',
                exact: true,
                component: PhoneWaiveUnitComponent
            },
            {
                path: '/phone/issue_overview',
                component: PhoneIssueOverviewComponent
            }
        ]
    },
    {
        path: '/',
        component: Home,
        routes: [
            {
                path: '/dashboard',
                exact: true,
                component: DashboardComponent
            },
            {
                path: '/user',
                exact: true,
                component: UserComponent
            },
            {
                path: '/role',
                exact: true,
                component: RoleComponent
            },
            {
                path: '/local_server_auth',
                exact: true,
                component: LocalServerAuthComponent
            },
            {
                path: '/fail_report',
                exact: true,
                component: FailReportComponent
            },
            {
                path: '/rma_tracking',
                exact: true,
                component: RMATrackingComponent
            },
            {
                path: '/svn_repository',
                exact: true,
                component: SvnRepositoryComponent
            },
            {
                path: '/file_sync',
                exact: true,
                component: FileSyncComponent
            },
            {
                path: '/analyzed_unit',
                component: AnalyzedUnitComponent,
                routes: [
                    {
                        path: '/analyzed_unit/:id',
                        exact: true,
                        component: EmptyDetailComponent
                    }
                ]
            },
            {
                path: '/update_limit',
                exact: true,
                component: UpdateLimitComponent
            },
            {
                path: '/issue_overview',
                exact: true,
                component: IssueOverviewComponent
            },
            {
                path: '/testing_files',
                exact: true,
                component: AllTestingFiles
            },
            {
                path: '/inventory',
                exact: true,
                component: EquipmentComponent
            },
            {
                path: '/other_sequence_parameters',
                exact: true,
                component: OtherSequenceParametersComponent
            },
            {
                path: '/file_sync/deleting_testing_file',
                exact: true,
                component: DeletingTestingFileComponent
            },
            {
                path: '/export_csv_by_serials',
                exact: true,
                component: ExportCsvBySerials
            },
            {
                path: '/refurbishment',
                exact: true,
                component: RefurbishmentComponent
            },
            {
                path: '/testing_data_filter',
                exact: true,
                component: TestingDataFilterComponent
            },
            {
                path: '/testing_data_batch_serial',
                exact: true,
                component: TestingDataBatchSerialComponent
            },
            {
                path: '/matchings',
                exact: true,
                component: MatchingList
            }
        ]
    }
]


export function RouteWithSubRoutes(route: any) {
    return <Route path={route.path} exact={route.exact || false} render={props => <route.component {...props} {...route.customParameters} routes={route.routes} />} />;
}


function EmptyDetailComponent(props: { match: any }) {
    const id = props.match.params.id - 0;
    const [currentId, setId] = useContext(DetailIdContext);

    useEffect(() => {
        setId(id);
    }, [id]);

    return <></>
}